import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useDashboardService } from 'src/apis/dashboard/useDashboardService';
import { IStaffDashboardData } from 'src/apis/dashboard/dashboardStaff.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getDashboardStaffKey = 'get-dashboard-staff';

export const useDashboardStaffHook = (
  options?: UseQueryOptions<IStaffDashboardData, TQueryError>
): UseQueryResult<IStaffDashboardData, TQueryError> => {
  const { getStaffDashboardData } = useDashboardService();

  return useQuery<IStaffDashboardData, TQueryError>({
    queryKey: [getDashboardStaffKey],
    queryFn: () => getStaffDashboardData(),
    enabled: true,
    ...options,
  });
};
